import {jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime"; function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import UploadFileIcon from '@mui/icons-material/UploadFile'
import graphql from 'babel-plugin-relay/macro'
import * as React from 'react'
import {useRef, useState} from 'react'
import {commitLocalUpdate, useFragment} from 'react-relay'
import orgAuthenticationMetadataQuery, {

} from '../../../../__generated__/OrgAuthenticationMetadataQuery.graphql'

import BasicInput from '../../../../components/InputField/BasicInput'
import SecondaryButton from '../../../../components/SecondaryButton'
import useAtmosphere from '../../../../hooks/useAtmosphere'
import useMutationProps from '../../../../hooks/useMutationProps'
import {useUploadIdPMetadata} from '../../../../mutations/useUploadIdPMetadataMutation'
import {Button} from '../../../../ui/Button/Button'
import getOAuthPopupFeatures from '../../../../utils/getOAuthPopupFeatures'
import getTokenFromSSO from '../../../../utils/getTokenFromSSO'

graphql`
  query OrgAuthenticationMetadataQuery($metadataURL: String!, $domain: String!) {
    viewer {
      parseSAMLMetadata(metadataURL: $metadataURL, domain: $domain) {
        ... on ErrorPayload {
          error {
            message
          }
        }
        ... on ParseSAMLMetadataSuccess {
          url
        }
      }
    }
  }
`





const OrgAuthenticationMetadata = (props) => {
  const {samlRef} = props
  const saml = useFragment(
    graphql`
      fragment OrgAuthenticationMetadata_saml on SAML {
        id
        metadataURL
        orgId
      }
    `,
    samlRef
  )
  const atmosphere = useAtmosphere()
  const [metadataURL, setMetadataURL] = useState(_nullishCoalesce(_optionalChain([saml, 'optionalAccess', _ => _.metadataURL]), () => ( '')))
  const isMetadataURLSaved = saml ? saml.metadataURL === metadataURL : false
  const {error, onCompleted, onError, submitMutation, submitting} = useMutationProps()
  const submitMetadataURL = async () => {
    if (submitting || !metadataURL) return
    submitMutation()
    const domain = _optionalChain([saml, 'optionalAccess', _2 => _2.id])
    if (!domain) {
      onError(new Error('Domain not provided. Please contact customer support'))
    }

    // Open popup before the first async call to prevent popup blockers
    const optimisticPopup = window.open(
      '',
      'SSO',
      getOAuthPopupFeatures({width: 385, height: 576, top: 64})
    )

    // Get the Sign-on URL, which includes metadataURL in the RelayState
    const res = await atmosphere.fetchQuery(
      orgAuthenticationMetadataQuery,
      {metadataURL, domain}
    )
    if (!res || res instanceof Error) {
      onError(new Error('Could not reach server. Please try again'))
      _optionalChain([optimisticPopup, 'optionalAccess', _3 => _3.close, 'call', _4 => _4()])
      return
    }
    const {viewer} = res
    const {parseSAMLMetadata} = viewer
    const {error} = parseSAMLMetadata
    if (error) {
      onError(new Error(error.message))
      _optionalChain([optimisticPopup, 'optionalAccess', _5 => _5.close, 'call', _6 => _6()])
      return
    }
    const url = parseSAMLMetadata.url

    // Attempt logging in to test for errors
    const response = await getTokenFromSSO(url)
    if ('error' in response) {
      onError(new Error(response.error || 'Error logging in'))
      return
    }
    onCompleted()
    commitLocalUpdate(atmosphere, (store) => {
      _optionalChain([store, 'access', _7 => _7.get, 'call', _8 => _8(saml.id), 'optionalAccess', _9 => _9.setValue, 'call', _10 => _10(metadataURL, 'metadataURL')])
    })
    atmosphere.eventEmitter.emit('addSnackbar', {
      message: 'SSO Configured Successfully',
      autoDismiss: 5,
      key: 'submitMetadata'
    })
  }

  const uploadInputRef = useRef(null)
  const onUploadClick = () => {
    _optionalChain([uploadInputRef, 'access', _11 => _11.current, 'optionalAccess', _12 => _12.click, 'call', _13 => _13()])
  }
  const [commit] = useUploadIdPMetadata()
  const uploadXML = (e) => {
    const {files} = e.currentTarget
    const file = _optionalChain([files, 'optionalAccess', _14 => _14[0]])
    if (!file || !_optionalChain([saml, 'optionalAccess', _15 => _15.orgId])) return
    commit({
      variables: {orgId: saml.orgId},
      uploadables: {file: file},
      onCompleted: (res) => {
        const {uploadIdPMetadata} = res
        const {error, url} = uploadIdPMetadata
        const message = _optionalChain([error, 'optionalAccess', _16 => _16.message])
        if (message) {
          atmosphere.eventEmitter.emit('addSnackbar', {
            key: 'errorUploadIdPtMetadata',
            message,
            autoDismiss: 5
          })
          return
        }
        setMetadataURL(url)
      }
    })
  }

  return (
    _jsxs(_Fragment, { children: [
      _jsxs('div', { className: "px-6 pb-3" , children: [
        _jsx('div', { className: "flex text-base leading-6 font-semibold text-slate-700"    , children: "Metadata URL" })
        , _jsx('div', { className: 'flex items-center text-sm text-slate-700', children: "Paste the metadata URL from your identity provider"

        })
      ]})
      , _jsxs('div', { className: "px-6 pb-3" , children: [
        _jsx(BasicInput, {
          name: "metadataURL",
          placeholder: `https://idp.example.com/app/sso/saml/metadata`,
          value: metadataURL,
          onChange: (e) => setMetadataURL(e.target.value),
          error: undefined,}
        )
        , _jsxs(Button, { className: "px-0", variant: "ghost", shape: "pill", size: "sm", onClick: onUploadClick, children: [
          _jsx(UploadFileIcon, { className: 'text-xl',} ), "Click to upload XML File"

        ]})
        , _jsx('input', {
          className: "hidden",
          accept: ".xml",
          onChange: uploadXML,
          type: "file",
          ref: uploadInputRef,}
        )
      ]})
      , _jsx('div', { className: 'px-6 text-tomato-500 empty:hidden', children: _optionalChain([error, 'optionalAccess', _17 => _17.message])})
      , _jsx('div', { className: "flex justify-end px-6 pb-8"   , children: 
        _jsx(SecondaryButton, {
          size: "medium",
          onClick: submitMetadataURL,
          disabled: submitting || isMetadataURLSaved,
 children: "Update Metadata"

        })
      })
    ]})
  )
}

export default OrgAuthenticationMetadata
